export default __webpack_public_path__ + "static/media/curveOverlay.7466eb9c.png";